export default __webpack_public_path__ + "static/media/GSK_Logo_Full_Colour_RGB.1a4b9185.png";